import React from 'react';
import { X, ChevronRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const GenericPopup = ({ isOpen, onClose, title, message, buttonText, onButtonClick, linkText, onLinkClick }) => {
    return (
        <AnimatePresence>
            {isOpen && (
                <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 backdrop-blur-sm">
                    <motion.div
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.95 }}
                        className="bg-[var(--popup-generic-bg-color)] rounded-xl w-[420px] pt-[40px] px-[32px] relative shadow-2xl flex flex-col"
                    >
                        <button
                            onClick={onClose}
                            className="absolute items-center justify-center top-[12px] right-[12px] text-[var(--popup-generic-sub-text-color)]"
                        >
                            <X size={24} />
                        </button>

                        <div className="flex flex-col gap-[16px]">
                            <h2 className="text-[var(--popup-generic-text-color)] text-[20px] font-semibold whitespace-pre-line leading-snug">
                                {title}
                            </h2>
                            <p className="text-[var(--popup-generic-sub-text-color)] text-[15px] whitespace-pre-line leading-relaxed">
                                {message}
                            </p>
                        </div>

                        {buttonText && (
                            <div className="flex py-[32px]">
                                <button
                                    onClick={() => { onButtonClick?.(); onClose(); }}
                                    className="w-full py-[13px] rounded-[4px] text-white font-semibold text-[14px] flex items-center justify-center shadow-lg transition-transform active:scale-[0.98]"
                                    style={{ background: 'var(--popup-generic-btn-bg-gradient)' }}
                                >
                                    {buttonText}
                                </button>
                            </div>
                        )}

                        {linkText && (
                            <div className="flex justify-end py-[32px]">
                                <button
                                    onClick={() => { onLinkClick?.(); onClose(); }}
                                    className="text-[var(--popup-generic-link-text-color)] text-[14px] font-medium flex items-center gap-1 hover:text-[#5faeff] transition-colors"
                                >
                                    {linkText} <ChevronRight size={16} />
                                </button>
                            </div>
                        )}
                    </motion.div>
                </div >
            )}
        </AnimatePresence >
    );
};

export default GenericPopup;
